import styled from 'styled-components';

export const ExpandedItemDetails = styled.div`
  display: ${props => ((props.show) ? 'block' : 'none')};
`;
